import React, { createContext, useState, useEffect } from "react";
import languageData from "./services/languageData.json";

// Создаем контекст
export const LangContext = createContext();

const LangProvider = ({ children }) => {
  // Состояние языка
  const [lang, setLang] = useState(() => {
    // Получаем язык из localStorage или ставим "ru" по умолчанию
    return localStorage.getItem("lang") || "ru";
  });

  // Переводы
  const [translations, setTranslations] = useState(languageData[lang]);

  // Обновляем переводы при смене языка
  useEffect(() => {
    setTranslations(languageData[lang]);
    localStorage.setItem("lang", lang); // Сохраняем язык в localStorage
  }, [lang]);

  // Функция для смены языка
  const changeLang = newLang => {
    if (languageData[newLang]) {
      setLang(newLang);
    }
  };

  return (
    <LangContext.Provider value={{ lang, translations, changeLang }}>
      {children}
    </LangContext.Provider>
  );
};

export default LangProvider;
